import { useQuery, useMutation } from "react-query";
import { toast } from "react-toastify";
import { TheMaticDemoServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin Brochure Master section
 */
const useListTheMaticDemo = (
  [page_no],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    ["thematicdemo-list", page_no],
    TheMaticDemoServices.theMaticDemoList,
    {
      onSuccess,
      keepPreviousData: true,
      onError,
    }
  );
};
const useAddTheMaticDemo = (onSuccess, onError = onDefaultError) => {
  return useMutation(TheMaticDemoServices.addTheMaticDemo, {
    onSuccess,
    onError,
  });
};
const useUpdateTheMaticDemo = (onSuccess, onError = onDefaultError) => {
  return useMutation(TheMaticDemoServices.updateTheMaticDemo, {
    onSuccess,
    onError,
  });
};
const useViewTheMaticDemo = (id, onSuccess, onError = onDefaultError) => {
  return useQuery(
    "thematicdemo-view",
    () => TheMaticDemoServices.viewTheMaticDemo({ id }),
    {
      onSuccess,
      onError,
    }
  );
};
const useTheMaticDemoDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(TheMaticDemoServices.deleteTheMaticDemo, {
    onSuccess,
    onError,
  });
};

export {
  useListTheMaticDemo,
  useAddTheMaticDemo,
  useUpdateTheMaticDemo,
  useViewTheMaticDemo,
  useTheMaticDemoDelete,
};
